import React, { useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import { ModalGenerico } from '../../../../components/ui'
import { ACTIONS } from '../../../../constants'
import { useSelector } from 'react-redux'

export const ModalAlteracionMenstruales = ({
  handleSubmit,
  handlerAction,
  action,
  reset,
  control,
  errors,
  setValue
}) => {
  const { activeAlterationMenstrual } = useSelector((state) => state.ui)

  useEffect(() => {
    if (activeAlterationMenstrual) {
      setValue('nombre', activeAlterationMenstrual.nombre)
      setValue('id', activeAlterationMenstrual.id)
    }
  }, [activeAlterationMenstrual])

  return (
    <ModalGenerico
      title="Alteraciones Menstruales"
      buttonCustom={() => (
        <Button
          variant="primary "
          size="md"
          style={{
            minWidth: '15%'
          }}
          onClick={handleSubmit(handlerAction)}
        >
          {action === ACTIONS.SAVE ? 'Guardar' : 'Actualizar'}
        </Button>
      )}
      closeButtonAction={reset}
    >
      <Form>
        <Form.Group className="mb-2">
          <Form.Label>Nombre de la AlteracionMenstrual</Form.Label>
          <Controller
            control={control}
            name="nombre"
            render={({ field }) => (
              <Form.Control
                type="text"
                placeholder="Nombre de la AlteracionMenstrual..."
                {...field}
              />
            )}
          />
          {errors.nombre && (
            <Form.Text className="text-danger">{errors?.nombre?.message}</Form.Text>
          )}
        </Form.Group>
      </Form>
    </ModalGenerico>
  )
}
